import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const pulseAnimation = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 0.3; }
  100% { opacity: 0.6; }
`;

export const BlurryBox = styled.div<{ width?: string; height?: string }>`
  width: ${({ width }) => (width ? width : '100px')};
  height: ${({ height }) => (height ? height : '16px')};
  background-color: var(--colorBlueGray200);
  border-radius: 4px;
  animation: ${pulseAnimation} 2s ease-in-out infinite;
`;
